export default {
  loading: "Завантаження...",
  too_many_requests: "Ваш пошук обмежений. Зареєструйте аккаунт щоб обійти обмеження або спробуйте ще раз.",
  session_expired: "Сесія закінчилася. Зайдіть в обліковий запис знову.",
  header_sign_out: "Вийти з облікового запису",
  header_login: "Зайти в обліковий запис",
  header_help: "Допомога",
  welcome_header: "Ласкаво просимо в програму підбору обладнання Philips",
  welcome_copy: "З програмою підбору Philips, легко можна знайти Philips-альтернативу будь-якої лампи або ПРА",
  welcome_feature_1: "Швидко знайти ваш продукт / продукти",
  welcome_feature_2: "Простий пошук і виведення результатів",
  welcome_feature_3: "Отримання всієї інформації і специфікації, необхідної для заміни продукту",
  login_title: "Зайти в обліковий запис",
  login_form_username: "Ім'я користувача",
  login_form_password: "Пароль",
  login_form_remember: "Залишатися онлайн",
  login_form_forgot_pswd: "Забули пароль?",
  login_form_login: "Зайти в обліковий запис",
  login_no_account_yet: "У Вас немає облікового запису?",
  login_request_account: "Зареєструвати обліковий запис",
  login_skip_request_explanation: "Якщо не заходити в систему, у вас є можливість знаходження продуктів, але з обмеженим функціоналом. Не буде доступна наступна інформація: технічні дані, порівняння характеристик, багаторазове введення/виведення даних або вивантаження даних. Для отримання повного доступу, будь ласка, створіть акаунт і збережіть пароль для легкого доступу.",
  login_skip_login_cta: "Не використовувати обліковий запис",
  login_credentials_invalid: "Адреса електронної пошти або пароль невірні.",
  login_forgot_pswd: "Забув пароль",
  login_forgot_pswd_content_one: "Ви забули пароль? Все добре, введіть Вашу ел.адресу, прив'язану до облікового запису",
  login_forgot_pswd_content_two: "Якщо Ви зареєстровані, ми надішлемо Вам посилання для скидання.",
  login_forgot_pswd_email: "Адреса електронної пошти",
  login_forgot_request_pswd: "Запросити новий пароль",
  login_forgot_invalid: "Некоректна адреса електронної пошти",
  login_successful: "Успішний вхід в обліковий запис",
  logout_successful: "Успішний вихід з облікового запису",
  home_search_for_product: "Знайдіть Ваш продукт",
  home_title: "Як це працює:",
  home_subtitle: "Насправді дуже просто",
  home_content_one: "Ми розробили панель пошуку для отримання швидких результатів",
  home_content_two: "Введіть код (частину коду) товару або опис, щоб отримати пропозицію про необхідний товар. Якщо у вас немає такої інформації, будь ласка, використовуйте фільтри, щоб дістатись до потрібного товару.",
  home_content_three: "Вибравши позицію, ви можете перевірити всю інформацію, необхідну для заміни. Після завершення ви можете вивантажити результати або шукати наступний товар.",
  home_contact_us: "Зв'яжіться з нами",
  request_account_title: "Запросити створення нового облікового запису",
  request_account_content_one: "З обліковим записом у Вас буде повний доступ до нашої пошукової програми, включаючи додаткові функції з вивантаження, множинне введення, введення за специфікацією та необмежений пошук",
  request_account_content_two: "Щоб підтвердити обліковий запис нам потрібна базова інформація про компанію",
  request_account_content_three: "Після підтвердження Ви отримаєте посилання на створення облікового запису",
  request_account_personal_information: "Персональна інформація",
  request_account_first_name: "Ім'я користувача",
  request_account_last_name: "Прізвище",
  request_account_email: "Електронна адреса",
  request_account_username: "(Це буде Ваше ім'я користувача)",
  request_account_password_1: "Пароль",
  request_account_password_2: "Повторити пароль",
  request_account_company: "Компанія",
  request_account_company_name: "Назва компанії",
  request_account_country: "Країна",
  request_account_job: "Посадa",
  agree_to_privacy_policy: "Я прочитав та згоден з політикою нерозголошення даних та умовами користування",
  validate_all_fields_required: "Всі поля обов'язкові",
  validate_agree_tac: "Ви повинні погодитись с умовами та вимогами",
  validate_passwords_dont_match: "Паролі не співпадають",
  validate_password_too_short: "Пароль повинен бути не менше 8 символів",
  validate_password_too_weak: "Пароль недостатньо безпечний",
  email_already_in_use: "Вже існує користувач з такою адресою електронної пошти",
  email_verify_in_progress: "Перевіряємо Вашу адресу електронної пошти",
  email_verified_success: "Ваша електронна адреса успішно підтверджена. Ви можете зайти в свій обліковий запис",
  email_verified_failed: "На жаль ми не змогли підтвердити Вашу електронну адресу",
  registration_successful: "Підтвердження адреси електронної пошти було надіслане на Вашу адресу електронної пошти",
  password_reset_failed: "Сталася помилка, спробуйте пізніше",
  password_reset_email_sent: "Ми надіслали Вам посилання для установки нового паролю",
  new_password_header: "Оберіть новий пароль",
  new_password: "Новий пароль",
  repeat_new_password: "Повторіть новий пароль",
  save_new_password: "Зберегти новий пароль",
  password_changed_success: "Пароль успішно змінений",
  request_account_request: "Запросити створення облікового запису",
  visual_input_code_title: "Введіть код товару / опис",
  visual_input_code_content: "Введіть назву товару, код чи шукайте з фільтрами",
  visual_hit_search_title: "Натисніть кнопку пошуку",
  visual_hit_search_content: "Готові? Натисніть кнопку пошуку для отримання результатів",
  visual_select_result_title: "Виберіть свій результат із списку пропозицій",
  visual_select_result_content: "Прокрутіть вниз, щоб знайти заміну ",
  search_input: "Напишіть код (частину коду) або опис",
  search_submit: "Шукати продукт",
  search_filter_product_type: "Тип продукту",
  search_filter_device: "Пристрій",
  search_filter_color: "Колір",
  search_filter_wattage: "Потужність",
  search_filter_brand: "Бренд",
  search_filter_show_all: "Показати фільтри",
  search_filter_hide_all: "Сховати фільтри",
  search_filter_clear_all: "Очистити фільтри",
  results_export: "Вивантажити результати",
  result_export_all: "Вивантажити усі результати",
  results: "Результати",
  results_shown: "Результат",
  no_results_found: "Результати не знайдені, спробуйте інший спосіб пошуку",
  results_no_recommendations: "Застрягли? Зв'яжіться з Вашим менеджером для вирішення проблеми",
  recommendations_singular: "Рекомендація",
  recommendations_plural: "Рекомендації",

  home_contact_us_content: "Should you require any further information or if you have any questions, feel free to contact us and we will be glad to assist you.",
  home_contact_us_first_name: "Ім'я користувача",
  home_contact_us_last_name: "Прізвище",
  home_contact_us_email: "Електронна адреса",
  home_contact_us_message: "Message",
  home_contact_us_submit: "Submit",
  home_contact_us_successfully: "Your message is successfully sent.",
  home_contact_us_error: "Something went wrong, please try again.",
  usage_disclaimer: "Intended only for the use of qualified Philips customers.",
  search_filter_bulb_finish: "Bulb finish",
  search_filter_bulb: "Bulb",
  search_filter_ignitor: "Ignitor",
  search_filter_packaging_configuration: "Packaging configuration",
  search_filter_fixture_feature: "Fixture feature",
  search_filter_base: "base",
  total_number_results: "Total number of results",
  results_specify: "There are more than 10 results, please further specify your search",

  //facets
  brand: "Бренд",
  discrete_wattage: "Потужність",
  wattage: "Потужність",
  type: "Type",
  color: "Колір",
  bulb_finish: "Bulb finish",
  subfamily: "Subfamily",
  bulb: "Bulb",
  ignitor: "Ignitor",
  packaging_configuration: "Packaging configuration",
  fixture_feature: "Fixture feature",
  family: "Family",
  base: "Base",
  pf_cap: "PF cap",
  number_of_lamps: "Number of lamps",
  lamp_current: "Lamp current",
  mains_frequency: "Mains frequency",
  driver_type: "Driver type",
  mains_voltage: "Mains voltage",
  height: "Height",
  weight: "Weight",
  thermal_protection: "Thermal protection",
  losses: "Losses",
  temp_range: "Temperature range",
  delta_temperature: "Delta temperature",
  life_class_tw: "Life class TW",
  wiring_diagram: "Wiring diagram",
  width: "Width",
  length: "Length",
  type_of_lamp: "Type of lamp",
  mounting_hole: "Mounting hole",
  power_factor: "Power factory",
  energy_efficiency: "Energy efficiency",
  product_description: "Product description",
  energy_saving: "Енергозбереження",

  //Match and result props
  apr: "APR",
  ean: "EAN",
  eu: "EU",
  latam: "Latam",
  material_description: "Material description",
  nam: "NAM",
  // product_code: "12NC",
  product_code: "Product code",
  remark: "Remark",
  valid: "Valid",

  card_action: "Catalogue",
  card_perfect_fit: "Philips Best Fit",
  card_alternative_fit: "Philips Best Alternative",
  card_show_more: "Show more",
  card_show_less: "Show less"
};
